<template>
  <div>
    <button
      class="rounded-lg bg-gray-200 p-2 flex items-center gap-2 fixed left-2 top-2 inline-block min-w-[120px]"
      @click="signOut"
    >
      <vue-feather type="log-out" class="h-4" />
      <div>Sign out</div>
    </button>

    <div class="w-11/12 max-w-3xl mx-auto mt-24 mb-12">
      <img v-if="team.logo" class="w-24 mb-12 mx-auto" :src="team.logo" />
      <h1 class="font-bold text-3xl text-center">Welcome to {{ team.company }}</h1>
      <p class="text-center text-gray-600 mt-4 max-w-xl mx-auto">
        We're super excited to have you. Please complete the following items as soon as possible so we can get you up
        and running!
      </p>

      <header v-if="incompleteTasks.length > 0" class="mt-12 text-sm text-gray-600 uppercase tracking-wider">
        Up Next
      </header>
      <div class="grid grid-cols-1 gap-1 mx-auto mt-2">
        <UserTaskPreviewCard
          v-for="(task, index) in incompleteTasks"
          :key="`tasks.${task.id}`"
          :task="task"
          :show-button="index == 0"
        />
      </div>
      <header v-if="completedTasks.length > 0" class="mt-12 text-sm text-gray-600 uppercase tracking-wider">
        Already Completed
      </header>
      <div class="grid grid-cols-1 gap-1 mx-auto mt-2">
        <UserTaskPreviewCard
          v-for="(task, index) in completedTasks"
          :key="`tasks.${task.id}`"
          :task="task"
          :show-button="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Layout from '../components/Layout/index.vue';
import UserTaskPreviewCard from '../components/user_tasks/UserTaskPreviewCard.vue';
import { confetti } from '@tsparticles/confetti';

export default {
  components: {
    Layout,
    UserTaskPreviewCard,
  },
  data() {
    return {
      userTasks: [],
      team: {},
      loaded: false,
    };
  },
  computed: {
    allTasksCompleted() {
      let completed = true;

      this.userTasks.forEach(task => {
        if (!this.isTaskCompleted(task)) {
          completed = false;
        }
      });

      return completed;
    },
    incompleteTasks() {
      return this.userTasks.filter(task => !this.isTaskCompleted(task));
    },
    completedTasks() {
      return this.userTasks.filter(task => this.isTaskCompleted(task));
    },
  },
  async mounted() {
    await this.fetchUserTasks();
    await this.fetchTeam();

    if (this.allTasksCompleted) {
      setTimeout(() => {
        confetti({
          particleCount: 100,
          spread: 70,
          origin: { y: 0.6 },
        });
      }, 1000);
    }
  },
  methods: {
    async fetchUserTasks() {
      const { records } = await this.$api.UserTasks.listUserTasks('/api/user_tasks');
      this.userTasks = records;
      this.loaded = true;
    },
    isTaskCompleted(task) {
      return task.status === 'completed';
    },
    async fetchTeam() {
      const { record } = await this.$api.Team.getTeam();

      this.team = record;
    },
    async signOut() {
      const res = await fetch('/users/sign_out', {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      });

      window.location.href = '/';
    },
  },
};
</script>
